export default __webpack_public_path__ + "static/media/schedule.796ec50e.svg";